import {
	useMutation,
	useQueryClient,
	type UseMutationOptions,
} from '@tanstack/react-query';
import {splitEventHandler} from '@netx/core-next/utils/fn';
import {
	setAttributeVocabulary,
	type QueryError,
	type SetAttributeVocabularyResult,
	type SetAttributeVocabularyRequestOptions,
} from '../setAttributeVocabulary';
export * from '../setAttributeVocabulary';
import {GetAttributeVocabularyReactQueryKey} from './useReactQueryGetAttributeVocabulary';

export type SetAttributeVocabularyQueryOptions = Omit<
	UseMutationOptions<
		SetAttributeVocabularyResult,
		QueryError,
		SetAttributeVocabularyRequestOptions,
		SetAttributeVocabularyResult
	>,
	'mutationFn'
> & {
	mutationFn?: typeof setAttributeVocabulary;
};

/**
 * react-query wrapper for `setAttributeVocabulary`
 * @param options
 */
export const useReactQuerySetAttributeVocabulary = ({
	mutationFn = setAttributeVocabulary,
	...options
}: SetAttributeVocabularyQueryOptions = {}) => {
	const queryClient = useQueryClient();

	return useMutation<
		SetAttributeVocabularyResult,
		QueryError,
		SetAttributeVocabularyRequestOptions,
		SetAttributeVocabularyResult
	>({
		mutationFn,
		...options,
		onSuccess: splitEventHandler(
			options.onSuccess,
			(data, variables, context) => {
				queryClient.invalidateQueries({
					queryKey: [GetAttributeVocabularyReactQueryKey, {id: variables.id}],
				});
			},
		),
	});
};

export default useReactQuerySetAttributeVocabulary;
